module.exports = __webpack_public_path__ + "img/remove-mail.cb263076.png";